import * as React from "react";

import { cn } from "@/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "tw-flex tw-min-h-[80px] tw-w-full tw-resize-none tw-rounded-lg tw-border tw-border-input tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-transition-colors placeholder:tw-text-muted-foreground focus-visible:tw-outline-none focus-visible:tw-border-primary hover:tw-border-primary/50 disabled:tw-cursor-not-allowed disabled:tw-opacity-50",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
